import { publicSaleConfig } from "../constants/publicSaleConfig";

export const getPublicSaleConfig = () => publicSaleConfig;
